import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

interface NavItem {
  label: string;
  path: string;
}

const navItems: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Capabilities', path: '/capabilities' },
  { label: 'About', path: '/about' },
];

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string): boolean => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo} onClick={closeMobileMenu} aria-label="Aedra home">
          <img
            src="/logo.svg"
            alt=""
            className={styles.logoImage}
            aria-hidden="true"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              if (target.src.includes('logo.svg')) {
                target.src = '/png.png';
              }
            }}
          />
          <span>Aedra</span>
        </Link>

        <nav className={styles.nav} aria-label="Main navigation">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`${styles.navLink} ${isActive(item.path) ? styles.active : ''}`}
              aria-current={isActive(item.path) ? 'page' : undefined}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className={styles.headerActions}>
          <Link to="/request" className={styles.purchaseButton}>
            Sign in
          </Link>
        </div>

        <div className={styles.mobileHeaderActions}>
          <button
            className={`${styles.mobileMenuButton} ${mobileMenuOpen ? styles.open : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-navigation"
          >
            <div className={styles.hamburger}>
              <span className={styles.hamburgerLine}></span>
              <span className={styles.hamburgerLine}></span>
              <span className={styles.hamburgerLine}></span>
            </div>
          </button>
        </div>
      </div>

      <nav
        id="mobile-navigation"
        className={`${styles.mobileNav} ${mobileMenuOpen ? styles.open : ''}`}
        aria-label="Mobile navigation"
        aria-hidden={!mobileMenuOpen}
      >
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`${styles.mobileNavLink} ${isActive(item.path) ? styles.active : ''}`}
            onClick={closeMobileMenu}
            aria-current={isActive(item.path) ? 'page' : undefined}
            tabIndex={mobileMenuOpen ? 0 : -1}
          >
            {item.label}
          </Link>
        ))}
        <div className={styles.mobileActions}>
          <Link
            to="/request"
            className={styles.mobilePurchaseButton}
            onClick={closeMobileMenu}
          >
            Sign in
          </Link>
        </div>
      </nav>
    </header>
  );
}
